import type { RouterOutputs } from "../../trpc";

type BroadcastItem = RouterOutputs["broadcast"]["list"][number];

export type UnifiedSendItem = {
  id: string;
  merchantId: string;
  name: string;
  status: "pending" | "processing" | "completed" | "failed";
  totalRecipients: number;
  sentCount: number;
  failedCount: number;
  deliveredCount: number;
  respondedCount: number;
  skippedOrNotSentCount: number;
  notContactableCount: number;
  /** Uploaded contacts that matched no lead we could address. */
  unreachableCount: number;
  progressPercentage: number;
  createdBy: string;
  createdAt: string;
};

export const toBroadcastSendItem = (b: BroadcastItem): UnifiedSendItem => ({
  id: b.id,
  merchantId: b.merchantId,
  name: b.name,
  status: b.status,
  totalRecipients: b.totalRecipients,
  sentCount: b.sentCount,
  failedCount: b.failedCount,
  deliveredCount: b.deliveredCount,
  respondedCount: b.respondedCount,
  skippedOrNotSentCount: b.existingNotSentCount,
  notContactableCount: b.notContactableCount,
  // Absent on broadcasts created before the counter existed — ElectroDB applies
  // an attribute default on write, not on read.
  unreachableCount: b.unreachableCount ?? 0,
  progressPercentage: b.progressPercentage,
  createdBy: b.createdBy,
  createdAt: b.createdAt,
});
